export const updateWrapper = (breakoutContainer) => {
	if (!document || !breakoutContainer) {
		return;
	}
	// Get all connect-app scripts at container, there can be multiple ones
	const allScripts = breakoutContainer.querySelectorAll('script.ap-iframe-body-script');
	if (!allScripts || allScripts.length === 0) {
		return;
	}
	// Total height of connect-app wrapper
	let totalHeight = 0;

	const parsePx = (matchedVal) => {
		// Parse % or px
		let addPx = '';
		if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) {
			addPx = 'px';
		}
		return addPx;
	};

	allScripts.forEach((iframeScript) => {
		// Get connect-app script html
		const scriptHtml = iframeScript?.innerHTML || '';

		if (scriptHtml) {
			const scriptWrapper = iframeScript.parentNode;

			// Extract connect-app height
			const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
			const matchedHeightVal = matchedHeight?.[1];
			if (matchedHeightVal) {
				const matchedInt = parseInt(matchedHeightVal);
				// Add this connect-app height to total height
				if (typeof matchedInt === 'number') {
					totalHeight += matchedInt;
				}
				// Preset connect-app wrapper height before iframe is injected
				if (scriptWrapper) {
					scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
				}
			}

			//Extract connect-app width
			const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
			const matchedWidthVal = matchedWidth?.[1];
			if (matchedWidthVal) {
				// Preset connect-app wrapper height before iframe is injected
				if (scriptWrapper) {
					scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
				}
			}
		}
	});

	// Preset connect-app wrapper height before iframe is injected, to prevent layout shift up and down multiple times
	document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
};

export const handleResize = (container) => {
	if (!document || !container) {
		return;
	}
	const appStatus: boolean[] = [];

	const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
	if (!allScripts || allScripts.length === 0) {
		return;
	}

	// Remove each connect-app wrapper preset width and height after iframe loaded
	allScripts.forEach((iframeScript) => {
		// Get connect-app parent
		const scriptWrapper = iframeScript.parentNode;
		const iframeLoaded = !!scriptWrapper.querySelector('iframe');
		const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
		const statusIndicatorHidden = statusIndicator?.style.display === 'none';
		// Check connect app loading status
		const isAppLoaded = iframeLoaded && statusIndicatorHidden;
		// Store each iframe's loading status
		appStatus.push(isAppLoaded);

		// If iframe is loaded, remove preset width and height
		if (isAppLoaded) {
			if (scriptWrapper?.style.height) {
				scriptWrapper.style.height = '';
			}
			if (scriptWrapper?.style.width) {
				scriptWrapper.style.width = '';
			}
		}
	});

	// Only reset container height after all iframes are loaded
	const allAppsLoaded = appStatus.every((status) => status === true);
	if (allAppsLoaded) {
		document.documentElement.style.setProperty(
			'--atl-general-webpanel-height',
			`${container.clientHeight}px`,
		);
		document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
	}
};
